<template>
  <div class="d-flex align-items-center apply-block mb-2">
    <div class="mr-1">
      Apply to:
    </div>

    <SelectTemplateDropdown
      :local-storage-key="LOCAL_STORAGE_KEY_SELECTED_TEMPLATES_FOR_BG_COLOR"
    />

    <b-dropdown
      ref="propertiesDropdown"
      size="sm"
      variant="primary"
      text="Actions"
      class="select-properties-dropdown mr-1"
      menu-class="p-0"
    >
      <b-list-group>
        <b-list-group-item
          v-for="(property, index) in properties"
          :key="index"
        >
          <b-form-checkbox
            v-model="property.value"
            size="sm"
            class="select-size"
            @change="updateSelectedProperties(property)"
          >
            {{ property.text }}
          </b-form-checkbox>
        </b-list-group-item>
        <b-list-group-item

          class="d-flex justify-content-end"
        >
          <b-button
            v-if="selectedProperties.length"
            size="sm"
            class="mr-2"
            variant="outlined"
            @click.prevent.stop="resetProperties"
          >
            Reset
          </b-button>
          <b-button
            size="sm"
            variant="primary"
            :disabled="!selectedProperties.length"
            @click="apply"
          >
            Apply
          </b-button>
        </b-list-group-item>
      </b-list-group>
    </b-dropdown>



    <ApplyInfoButton />
  </div>
</template>

<script>
/* eslint vue/enforce-style-attribute: 0 */
import SelectTemplateDropdown from './SelectTemplateDropdown.vue';
import {editorControlEventBroker, EVENTS} from '@frontend/group/modules/editor-control-popup/event-broker';
import {
  LOCAL_STORAGE_KEY_SELECTED_TEMPLATES_FOR_BG_COLOR,
} from '@frontend/group/modules/editor-control-popup/selected-template-for-apply-to-all'
import ApplyInfoButton from '@frontend/components/modules/layouts-page/EditorControl/components/ApplyInfoButton.vue'

export default {
  name: 'ApplyToBackgroundColorDropdown',

  components: { ApplyInfoButton, SelectTemplateDropdown},

  props: {
    target: {
      type: Object,
      default: () => {
      },
    },
  },

  data() {
    return {
      LOCAL_STORAGE_KEY_SELECTED_TEMPLATES_FOR_BG_COLOR,
      isApplyToAll: false,
      properties: [
        {
          text: 'Update Color',
          key: 'update_color',
          value: false,
          instance_id: this.target.canvas.instance_id,
          backgroundElementId: this.target.id
        },
        {
          text: 'No Color',
          key: 'no_color',
          value: false,
          instance_id: this.target.canvas.instance_id,
          backgroundElementId: this.target.id
        },
      ],
      selectedProperties: []
    };
  },

  methods: {
    apply() {
      if (!this.target?.canvas) return;

      // The ids in `properties` were captured when the dropdown was created; the selection
      // (and even the page) may have changed since - resolve from the live target instead.
      this.selectedProperties.forEach((property) => {
        property.instance_id = this.target.canvas.instance_id;
        property.backgroundElementId = this.target.id;
      });

      editorControlEventBroker.fire(EVENTS.BG_COLOR_CHANGED, this.selectedProperties);
      this.resetProperties();
      this.$refs.propertiesDropdown.hide();
    },
    updateSelectedProperties(property) {
      if (property.value) {
        if (property.key === 'show') {
          this.setPropertyValue('hide', false);
        } else if (property.key === 'hide') {
          this.setPropertyValue('show', false);
        } else if (property.key === 'delete') {
          this.properties.forEach(prop => {
            if (prop.key !== 'delete') {
              prop.value = false;
            }
          });
          this.selectedProperties = [property];
          return;
        }

        if (!this.selectedProperties.some((p) => p.key === property.key)) {
          this.selectedProperties.push(property);
        }
      } else {
        this.selectedProperties = this.selectedProperties.filter((p) => p.key !== property.key);
      }
    },
    setPropertyValue(key, value) {
      const property = this.properties.find(p => p.key === key);
      if (property) {
        property.value = value;
        this.selectedProperties = this.selectedProperties.filter(p => p.key !== key);
      }
    },
    resetProperties() {
      this.properties.forEach(property => {
        property.value = false;
      });

      this.selectedProperties = [];
    },
  },
};
</script>

<style lang="scss">
.align-items-start {
  flex-wrap: wrap;

  .image-editor-actions--bg-actions {
    max-width: 100%;
  }
  .select-size {
    width: 170px;
  }
}
</style>
